module.exports = __webpack_public_path__ + "img/mpBigQrCode.b943c2aa.png";